import { Accordion, Stack, Text } from "@mantine/core"
import { ForecastDetailsSections } from "atlas_forecasting_app/components/forecast/forecast_details_sections"
import { ForecastDisplay } from "atlas_forecasting_app/components/forecast/forecast_display"

export function ContributingForecastsSection({ question, forecasts }) {
  const completedForecasts = Array.isArray(forecasts) ? forecasts.filter((forecast) => forecast?.status === "completed") : []
  if (completedForecasts.length === 0) return null

  return (
    <Accordion variant="contained" radius="md">
      {completedForecasts.map((forecast) => (
        <Accordion.Item key={forecast.id || `${forecast.slot}-${forecast.attempt_number}`} value={`slot-${forecast.slot}`}>
          <Accordion.Control>
            <Stack gap={2}>
              <Text fw={500}>Contributing forecast {forecast.slot}</Text>
            </Stack>
          </Accordion.Control>
          <Accordion.Panel>
            <Stack gap="md">
              <ForecastDisplay question={question} forecastData={forecast.forecast_data} />
              <ForecastDetailsSections
                writeUp={forecast.write_up}
                calculationCode={forecast.calculation_code}
              />
            </Stack>
          </Accordion.Panel>
        </Accordion.Item>
      ))}
    </Accordion>
  )
}
